import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const money = (v) => v.toLocaleString(undefined, { style: "currency", currency: "EUR" });

const Big = ({ label, value, id }) => (
  <div className="border-l border-[#2E252A] pl-5">
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E665D]">{label}</p>
    <p className="font-serif text-3xl text-[#F5F0EB] mt-1" data-testid={id}>{value}</p>
  </div>
);

const Breakdown = ({ title, rows, max, id }) => (
  <div className="rounded-xl border border-[#2E252A] bg-[#161214] p-6" data-testid={id}>
    <h3 className="font-serif text-2xl text-[#D4AF37] mb-5">{title}</h3>
    <div className="space-y-4">
      {rows.map((r) => (
        <div key={r.name}>
          <div className="flex justify-between text-sm mb-1.5">
            <span className="text-[#F5F0EB]">{r.name}</span>
            <span className="font-mono text-[#A89F91]">{r.bottles} btl · {money(r.value)}</span>
          </div>
          <div className="h-1 rounded bg-[#2E252A]"><div className="h-1 rounded bg-[#8C2B36]" style={{ width: `${max ? (r.value / max) * 100 : 0}%` }} /></div>
        </div>
      ))}
      {!rows.length && <p className="text-sm text-[#6E665D]">No bottles in the cellar.</p>}
    </div>
  </div>
);

export default function Value() {
  const [v, setV] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    api.get("/value").then((r) => setV(r.data)).catch(() => setFailed(true));
  }, []);
  if (!v) {
    return <p className="px-8 py-12 font-mono text-sm text-[#6E665D]" data-testid="value-loading">{failed ? "Could not load the cellar value. Please refresh." : "Counting bottles…"}</p>;
  }
  const max = (rows) => Math.max(0, ...rows.map((r) => r.value));
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">At purchase price</p>
      <h2 className="font-serif text-4xl sm:text-5xl text-[#F5F0EB] mb-10">Cellar value</h2>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-10">
        <Big label="Total value" value={money(v.value)} id="value-total" />
        <Big label="Bottles in cellar" value={v.bottles} id="value-bottles" />
        <Big label="Consumed" value={v.out.consumed} id="value-consumed" />
        <Big label="Sold" value={`${v.out.sold} · ${money(v.sales_total)}`} id="value-sold" />
        <Big label="Lost" value={v.out.lost} id="value-lost" />
      </div>
      {v.priced < v.bottles && <p className="text-sm text-[#E5A93C] mb-6" data-testid="value-unpriced-warning">{v.bottles - v.priced} bottles have no purchase price and count as 0.</p>}
      <div className="grid lg:grid-cols-2 gap-6">
        <Breakdown title="By location" rows={v.by_location} max={max(v.by_location)} id="value-by-location" />
        <Breakdown title="By producer" rows={v.by_producer} max={max(v.by_producer)} id="value-by-producer" />
      </div>
    </div>
  );
}
